import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import ProductsDetails from '../../components/Pages/Products';

const { displayName } = config;

export default function Products(): React.ReactNode | null {
  document.title = `${displayName}: Products details`;

  return (
    <Layout>
      <ProductsDetails />
    </Layout>
  );
}
